export const GET_DASHBOARD_STATS = 'GET_DASHBOARD_STATS';
export const SET_DASHBOARD_STATS = 'SET_DASHBOARD_STATS';
export const GET_DASHBOARD_STATS_ERROR = 'GET_DASHBOARD_STATS_ERROR';
export const SET_MAP_STATS = 'SET_MAP_STATS';

export const SET_DASHBOARD_LEADS = 'SET_DASHBOARD_LEADS';
